import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import formControl from '../formControl';
import format from './format';
import normalizePhoneNumber from './normalizePhoneNumber';

import * as styles from './styles.css';
import deepShouldUpdate from '../../../lib/deepShouldUpdate';
import PhoneNumber from '../../PhoneNumber';

class PhoneNumberInput extends Component {
  static defaultProps = {
    disabled: false,
    isEditable: true,
  };

  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
    disabled: PropTypes.bool,
    isEditable: PropTypes.bool,
  };

  static format = format;
  static normalizePhoneNumber = normalizePhoneNumber;

  render() {
    if (this.props.isEditable === false) {
      return (
        <div className={styles.value}>
          <PhoneNumber isFormatted>{this.props.input.value}</PhoneNumber>
        </div>
      );
    }
    return (
      <input
        {...this.props.input}
        {...this.props.field}
        disabled={this.props.disabled}
        className="form-control"
      />
    );
  }
}

export default compose(
  deepShouldUpdate,
  formControl,
)(PhoneNumberInput);
